"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.environmentDetails = exports.SupportedBrowserVendors = void 0;
exports.getClientEnvironmentDetails = getClientEnvironmentDetails;
exports.isBrowserSupported = isBrowserSupported;
var _bowser = _interopRequireDefault(require("bowser"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Environment Details
 * @typedef {Object}
 * @property {boolean} isNode
 * @property {boolean} isBrowser
 * @property {boolean} isDesktop
 * @property {boolean} isHeadlessChrome
 * @property {boolean} isMobile
 * @property {boolean} isTablet
 * @property {boolean} isIOS
 * @property {boolean} isAndroid
 * @property {Object} clientWindowSize
 * @property {string} clientWindowSize.width
 * @property {string} clientWindowSize.height
 * @memberof module:@sm/utils
 */
var environmentDetails = {
  isNode: false,
  isBrowser: false,
  isDesktop: false,
  isHeadlessChrome: false,
  isMobile: false,
  isTablet: false,
  isIOS: false,
  isAndroid: false,
  clientWindowSize: {
    width: undefined,
    height: undefined
  }
};
exports.environmentDetails = environmentDetails;
var userAgentTracker = '';

/**
 * inspectAgent
 * @param {string} userAgent The string for the user agent
 */
function inspectAgent(userAgent) {
  if (!userAgent) {
    return;
  }
  if (userAgent.match(/iPhone|iPod|iPad/i) !== null) {
    environmentDetails.isIOS = true;
    if (userAgent.match(/iPad/i) !== null) {
      environmentDetails.isTablet = true;
    } else {
      environmentDetails.isMobile = true;
    }
  } else if (userAgent.match(/Android/i) !== null) {
    environmentDetails.isMobile = true;
    environmentDetails.isAndroid = true;
  } else if (userAgent.match(/HeadlessChrome/i) !== null) {
    environmentDetails.isHeadlessChrome = true;
  } else {
    environmentDetails.isDesktop = true;
  }
}

/**
 * Initialize
 * @param {string} userAgent The string for the user agent
 * @private
 */
function _initialize(userAgent) {
  var ua = userAgent;
  if (typeof window === 'object') {
    environmentDetails.isBrowser = true;
    window.SM = window.SM || {};
    var _window = window,
      SM = _window.SM;
    SM.__LOAD_PAYLOAD_CACHE__ = SM.__LOAD_PAYLOAD_CACHE__ || {};
    // Detect banner type (iOS or Android)
    environmentDetails.clientWindowSize = {
      width: document.body.clientWidth,
      height: document.body.clientHeight
    };
    ua = navigator.userAgent;
  } else {
    environmentDetails.isNode = true;
  }
  inspectAgent(ua);
}

/**
 * Returns the environment details
 * @param {string} userAgent The string for the user agent
 * @returns {environmentDetails} env details
 * @memberof module:@sm/utils
 */
function getClientEnvironmentDetails() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (environmentDetails.isBrowser === false && environmentDetails.isNode === false || userAgentTracker !== userAgent) {
    userAgentTracker = userAgent;
    _initialize(userAgentTracker);
  }
  return environmentDetails;
}
var SupportedBrowserVendors;
exports.SupportedBrowserVendors = SupportedBrowserVendors;
(function (SupportedBrowserVendors) {
  SupportedBrowserVendors["Chrome"] = "chrome";
  SupportedBrowserVendors["Firefox"] = "firefox";
  SupportedBrowserVendors["Safari"] = "safari";
  SupportedBrowserVendors["IE"] = "ie";
  SupportedBrowserVendors["Edge"] = "edge";
})(SupportedBrowserVendors || (exports.SupportedBrowserVendors = SupportedBrowserVendors = {}));
var defaultSupportedBrowsers = [{
  vendor: SupportedBrowserVendors.Chrome,
  operator: '>=',
  version: '18'
}, {
  vendor: SupportedBrowserVendors.Firefox,
  operator: '>=',
  version: '24'
}, {
  vendor: SupportedBrowserVendors.Safari,
  operator: '>=',
  version: '7'
}, {
  vendor: SupportedBrowserVendors.Edge,
  operator: '>=',
  version: '12'
}, {
  vendor: SupportedBrowserVendors.IE,
  operator: '>=',
  version: '11'
}];
function isBrowserSupported(userAgent, supportedBrowsers) {
  var browser = _bowser.default.getParser(userAgent);
  var browsers = supportedBrowsers || defaultSupportedBrowsers;
  browsers.forEach(function (_ref) {
    var version = _ref.version;
    if (!version.match(/^\d+(\.\d+)?(\.\d+)?$/)) {
      throw new Error("Unsupported version number: ".concat(version));
    }
  });
  var config = browsers.reduce(function (cfg, _ref2) {
    var vendor = _ref2.vendor,
      operator = _ref2.operator,
      version = _ref2.version;
    cfg[vendor] = "".concat(operator).concat(version);
    return cfg;
  }, {});
  return browser.satisfies(config) || false;
}
//# sourceMappingURL=index.js.map